import React, { useEffect, useState } from 'react'
import TopNavigation from '../../layouts/top-navigation/TopNavigation'
import ApplicantInfo from './ApplicantNav/ApplicantInfo'
import AuditHistory from './ApplicantNav/AuditHistory'
import Notes from './ApplicantNav/Notes'
import ViewApplicantNavigation from './ApplicantNav/viewApplicantNavigation'
import ViewApplicantsSidebar from './ViewApplicantsSidebar'
import { useAppDispatch, useAppSelector } from '../../useStore'
import { getallapplicantbyID, reset } from '../../features/Applicant/applicantSlice'
import { useParams } from 'react-router-dom'
import swal from "sweetalert";


const ViewApplicants = (setShow: any, show: any) => {
	const { id } = useParams();
	const dispatch = useAppDispatch();
	const { dataID, isErrorID, isLoadingID, messageID } = useAppSelector((state: any) => state.applicant)



	useEffect(() => {
		if (isErrorID) {
			swal({
				title: "error",
				text: messageID,
				icon: "error"
			})
			dispatch(reset())
		}

	}, [dispatch, isErrorID, messageID])

	useEffect(() => {
		// @ts-ignore
		dispatch(getallapplicantbyID(id));
	}, [dispatch, id]);


	const [active, setActive] = useState<string>('/ApplicantInfo')

	return (
		<div id="screen-wrapper">
			<TopNavigation />
			<ViewApplicantsSidebar data={dataID?.data} isLoadingID={isLoadingID} />

			<main>
				<div className='viewsidebarcontentmain' id='screen-wrapper-applicant-grid'>
					<ViewApplicantNavigation setActive={setActive} />
					<div >
						{active === "/ApplicantInfo" && <ApplicantInfo data={dataID?.data} isLoadingID={isLoadingID} />}
						{active === "/AuditHistory" && <AuditHistory data={dataID?.data} isLoadingID={isLoadingID} />}
						{active === "/Notes" && <Notes />}

					</div>
				</div>
			</main>
		</div>
	)
}

export default ViewApplicants